export const isProcessingTimeChecked = (menuOffer): boolean =>
  menuOffer.offerDialogUseProcessingTime || false;
